import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { initialize, reduxForm, Field } from 'redux-form';
import { useHistory } from "react-router-dom";
import i18n from 'i18next';

import PageTitle from '../../components/UI/PageTitle';
import PageContainer from '../../components/UI/PageContainer';
import ContentContainer from '../../components/UI/ContentContainer';
import Spacer from '../../components/UI/Spacer';
import FormButton from '../../components/UI/FormButton';

import { 
    renderFieldOneColumn,
    renderFieldTwoColumns,
    renderTextareaTwoColumns
} from '../../components/UI/Fileds';

import { sendTask } from '../../actions/task';
import { startLoading, endLoading } from '../../actions/ui';

import { showError, showConfirmation } from '../../helpers/messages';
import { stringTrim } from '../../helpers/converter';

const ScreensTaskForm = ({ submitting, handleSubmit, reset, dirty }) => {
    
    const { t } = useTranslation();

    const { selected } = useSelector(state => state.task);

    const dispatch = useDispatch();

    const history = useHistory();

    useEffect(() => {
        if (selected) {
            dispatch(initialize('taskForm', {
                id: selected.id,
                titulo: selected.titulo,
                descripcion: selected.descripcion
            }));
        } else {
            dispatch(initialize('taskForm', { titulo: '', descripcion: '' }));
        }
    }, [dispatch, selected]);

    const handleSend = (values) => {
        dispatch(startLoading());

        dispatch(
            sendTask({Tareas: {
                ...values,
                titulo: stringTrim(values.titulo),
                descripcion: stringTrim(values.descripcion)
            }})
        ).then((res) => {
            dispatch(endLoading());

            if (res.ok) {
                history.goBack();
            } else {
                showError(t('message-title-error'), t(res.message));
            }
        });
    };

    const handleCancel = () => {
        if (dirty) {
            showConfirmation(
                t('message-title-confirmation'),
                t('message-abandom-form-text'),
                t('button-title-exit'),
                t('button-title-keep-here'),
                () => {
                    history.goBack();
                } 
            );
        } else {
            history.goBack();
        }        
    };

    const renderForm = () => {
        return (
            <form onSubmit={ handleSubmit(handleSend) }>
                <div className="row margin">
                    {
                        (selected)
                            ? (
                                <Field
                                    type="hidden" 
                                    name="id" 
                                    id="id"
                                    component={ renderFieldOneColumn }
                                />
                            )
                            : ''
                    }

                    <Field type="text" name="titulo" id="titulo" 
                        label={ t('screens-task-list-titulo') } 
                        placeholder=""
                        component={ renderFieldTwoColumns } 
                        icon="text_fields" 
                        key="titulo"
                    />

                    <Field name="descripcion" id="descripcion" 
                        label={ t('screens-task-list-descripcion') } 
                        placeholder=""
                        component={ renderTextareaTwoColumns } 
                        icon="assignment" 
                        key="descripcion"
                    />
                </div>

                <div className="row">
                    <div className="input-field col s12">
                        <FormButton type="submit"
                            title={ t('form-button-send') }
                            disabled={ submitting }
                        />

                        <FormButton type="reset"
                            title={ t('form-button-cancel') }
                            disabled={ submitting }
                            onClick={ handleCancel }
                        />
                    </div>
                </div>
            </form>
        );
    };
    return (
        <PageContainer>    
            <PageTitle title={ t('screens-task-form-title') } />

            <ContentContainer>
                { renderForm() }
            </ContentContainer>

            <Spacer height="5" />
        </PageContainer>
    );

};

const validate = (values) => {
    const errors = {};

    if (!values.titulo) {
        errors.titulo = i18n.t('validator-error-titulo');
    }

    if (!values.descripcion) {
        errors.descripcion = i18n.t('validator-error-descripcion');
    }

    return errors;
};

export default reduxForm({
    form: 'taskForm',
    validate: validate,
    destroyOnUnmount: false //true
})(ScreensTaskForm);